<script>
export default {
  name: "AnimatedNumbers",
  props: {
    time: {
      type: Number,
      default: 1000
    },
    tag: {
      type: String,
      default: "div"
    },
  },
  data() {
    return {
      max: 0,
      min: 0,
      progress: 0,
      numFractional: 0,
      fractionalSeparator: ",",
    }
  },
  computed: {
    value() {
      function parametricBlend(t) {
          const sqt = t * t;
          return sqt / (2.0 * (sqt - t) + 1.0);
      }

      const progress = parametricBlend(this.progress);

      return (((this.max - this.min) * progress + this.min).toFixed(this.numFractional)).split(".").join(this.fractionalSeparator);
    },
  },
  methods: {
    start() {
      const beginTime = Date.now();

      if (this.interval) {
        clearInterval(this.interval);
      }

      this.interval = setInterval(() => {
        const currentTime = Date.now();
        this.progress = Math.max(Math.min((currentTime - beginTime) / this.time, 1), 0);

        if (this.progress === 1) {
          clearInterval(this.interval);
          this.interval = null;
        }
      }, 20);
    }
  },
  mounted() {
    let string = this.$slots.default()[0].children || "0";

    if (string.includes(",")) {
      string = string.split(",").join(".");
      this.fractionalSeparator = ",";
    } else {
      this.fractionalSeparator = ".";
    }

    this.numFractional = string.length - string.indexOf(".") - 1;
    
    if (this.numFractional >= string.length) {
      this.numFractional = 0;
    }

    this.max = parseFloat(string);

    this.$root.observeView(this.$el, () => {
      this.start();
    });
  }
};
</script>

<template>
  <span>
    {{ value }}
  </span>
</template>
